import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ac1d53c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1d53c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac1d53c')) {
      api.createRecord('0ac1d53c', component.options)
    } else {
      api.reload('0ac1d53c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ac1d53c&scoped=true", function () {
      api.rerender('0ac1d53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WordParser/index.vue"
export default component.exports